import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'

class H3 extends React.Component {
    render(){
        return (
            <Flex shrink={0}className={style.Label} vAlignContent='center'  {...this.props}>
                {this.props.children}
            </Flex>
        )
    }

}

export default H3



// WEBPACK FOOTER //
// ./src/component/Html/H3/index.js